// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireFilledSvg from "@fishx/icons-svg/es/asn/FireFilled";
import FishxIcon from '../components/FishxIcon';

var FireFilled = function FireFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireFilledSvg
  }));
};

FireFilled.displayName = 'FireFilled';
export default React.forwardRef(FireFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FireFilled.js
// module id = 2780
// module chunks = 0